module.exports = __webpack_public_path__ + "img/IMG_2671_L.94880945.webp";